"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const app_platform_value_type_definitions_1 = require("@semios/app-platform-value-type-definitions");
exports.requestSchema = app_platform_value_type_definitions_1.VV.requestSchema;
exports.path = '/values';
//# sourceMappingURL=index.js.map